import { render } from "./School.vue?vue&type=template&id=16df0f84&scoped=true&ts=true"
import script from "./School.vue?vue&type=script&lang=ts"
export * from "./School.vue?vue&type=script&lang=ts"

import "./School.vue?vue&type=style&index=0&id=16df0f84&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16df0f84"]])

export default __exports__